    <div class="dialog-container">
      <div fxLayout="row wrap" fxLayoutAlign="space-between" class="border-bottom title-bar">
        <h3 class="arc-h2 margin-20" matDialogTitle>{{ title }}</h3>
        <div class="text-right mr-2">
          <app-close-mat-dialog (closeDialog)="cancelConfirmation()"></app-close-mat-dialog>
        </div>
      </div>
      <mat-dialog-content class="dialog-content">
        <div fxLayout="column" class="content-wrapper">
          <div class="arc-dialog-text">
            {{ message }}
          </div>
          
      <app-common-grid *ngIf="showGrid" [rows]="dataRows" [columns]="columns"></app-common-grid>
        </div>
      </mat-dialog-content>
      <mat-divider></mat-divider>
      <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
        <button class="margin-right-20" id="notification-dialog-close-btn" mat-button color="primary" appDebounceClick (debounceClick)="cancelConfirmation()">
          CLOSE
        </button>
      </mat-dialog-actions>
    </div>
  